import { useMemo } from 'react';
import { Table } from 'antd';
import type { CSSProperties } from 'react';
import type { ColumnsType } from 'antd/es/table';
import {
  renderInventoryLotCell,
  type InventoryListCellContext,
} from './inventoryListCells';
import { EXPAND_COLUMN_WIDTH } from './inventoryListStyled';
import {
  buildLotRows,
  getLotRowKey,
  type InventoryListApiItem,
  type InventoryListColumnKey,
  type InventoryLotRow,
} from './inventoryListTypes';

const CELL_STYLE: CSSProperties = {
  verticalAlign: 'middle',
  background: '#FAFAFA',
};

const COLUMN_DEFS: { key: InventoryListColumnKey; width: string }[] = [
  { key: 'description', width: '22%' },
  { key: 'location', width: '14%' },
  { key: 'carton_configurations', width: '20%' },
  { key: 'on_hand', width: '8%' },
  { key: 'transfer', width: '8%' },
  { key: 'allocated', width: '8%' },
  { key: 'total', width: '8%' },
  { key: 'actions', width: '12%' },
];

type InventoryLotSubTableProps = {
  item: InventoryListApiItem;
  cellCtx: InventoryListCellContext;
};

export function InventoryLotSubTable({ item, cellCtx }: InventoryLotSubTableProps) {
  const lotRows = useMemo(() => buildLotRows(item), [item]);

  const columns: ColumnsType<InventoryLotRow> = useMemo(() => {
    const dataColumns = COLUMN_DEFS.map(col => ({
      key: col.key,
      width: col.width,
      align: ['on_hand', 'transfer', 'allocated', 'total'].includes(col.key)
        ? ('right' as const)
        : undefined,
      onCell: () => ({ style: CELL_STYLE }),
      render: (_: unknown, record: InventoryLotRow) =>
        renderInventoryLotCell(col.key, record, cellCtx),
    }));

    return [
      dataColumns[0],
      {
        key: 'expand-spacer',
        width: EXPAND_COLUMN_WIDTH,
        onCell: () => ({ style: CELL_STYLE }),
        render: () => null,
      },
      ...dataColumns.slice(1),
    ];
  }, [cellCtx]);

  return (
    <Table<InventoryLotRow>
      className="inventory-list-lot-table"
      rowKey={getLotRowKey}
      columns={columns}
      dataSource={lotRows}
      pagination={false}
      showHeader={false}
      size="middle"
      tableLayout="fixed"
    />
  );
}
